import { postApi } from "../../Shared/Services/RestService";
import { FeedbackResponseDto } from "../../Admin/Types/FeedbackType";

export interface ContactInquiryPayload {
  name: string;
  email: string;
  subject: string;
  message: string;
  profileRole?: string;
}

/**
 * Public Contact-Us submission - no login. The backend stores it as feedback with
 * sourceFrom WEB-DIRECT and notifies the support admins.
 */
export const submitContactInquiry = (payload: ContactInquiryPayload) => {
  return postApi<FeedbackResponseDto>("/public/feedbacks", payload);
};
